import { render, staticRenderFns } from "./AddEditEducationPlan.vue?vue&type=template&id=191f73b3"
import script from "./AddEditEducationPlan.vue?vue&type=script&lang=js"
export * from "./AddEditEducationPlan.vue?vue&type=script&lang=js"
import style0 from "./AddEditEducationPlan.vue?vue&type=style&index=0&id=191f73b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports